import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ReactFCV } from '@types';

import { ECartPageState, useCartPageContext } from '../../../../context';
import { messages } from '../../messages';

import { IInsuranceDescriptionProps } from './model';
import { StyledDescriptionWrapper, StyledLink } from './styled';

export const InsuranceDescription: ReactFCV<IInsuranceDescriptionProps> = ({ infoText }) => {
  const {
    actions: { setCartPageState },
  } = useCartPageContext();

  const handleMoreInfoClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setCartPageState(ECartPageState.INSURANCE_SERVICE_INFO_MODAL);
  };
  return (
    <>
      <StyledDescriptionWrapper dangerouslySetInnerHTML={{ __html: infoText }} />
      <StyledLink onClick={handleMoreInfoClick}>
        <FormattedMessage {...messages.giftWrappingLinkText} />
      </StyledLink>
    </>
  );
};
